import NextLink from "next/link";
import { Icons, ChakraLink as Link } from "@airhelp/react-ui-components";
import type { IconLinkProps } from "./IconLink.d";

const IconLink = ({ icon, text = "", href, prefetch = false, ...props }: IconLinkProps) => (
  <Link
    as={NextLink}
    href={href}
    passHref
    prefetch={prefetch}
    display="inline-flex"
    alignItems="center"
    color="primary.500"
    fontWeight="semibold"
    _hover={{
      textDecor: "none",
    }}
    {...props}
  >
    {text}
    {icon || <Icons.ArrowRight mt={0.5} ml={3} />}
  </Link>
);

export default IconLink;
